import { Matrix } from "./matrix"


abstract class Block {

    matrix: Matrix<string | boolean | null | undefined>
    rowAmount: number
    colAmount: number

    constructor (rawMatrix: Array<Array<string | boolean | null>>) {
        this.matrix = Matrix.fromArray(rawMatrix)
        this.rowAmount = this.matrix.length
        this.colAmount = this.matrix[0]?.length || 0
    }

}

export { Block }
